import { Highlight } from 'react-instantsearch'

import type { Hit, BaseHit } from 'instantsearch.js'
import type { ReactElement } from 'react'
import type { IPlaceholderRule } from '~/types/template'
import type { ITranslationKeyValue } from '~/types/translation'

import InputControls from '../../../Controls'
import WarningTooltip from '../../WarningTooltip'

import { LokaliseProjectBadge } from '~/components/Badges'

interface Props {
  hit: Hit<BaseHit> &
    ITranslationKeyValue & {
      onClick: VoidFunction
      rules?: IPlaceholderRule[]
      translation: ITranslationKeyValue
    }
}

const CustomHit = ({ hit }: Props): ReactElement => {
  const { key, lokalise_project_id, lokalise_project_name, onClick, rules, translation } = hit

  return (
    <div className="hit-container" onClick={onClick}>
      <div className="hit-row">
        <div className="hit-row__key">
          <Highlight attribute="key" hit={hit} />
          <WarningTooltip rules={rules} translation={translation} />
          <InputControls copyValue={key} translationKey={key} translationProject={lokalise_project_id} />
        </div>
        <LokaliseProjectBadge value={lokalise_project_name} />
      </div>
      <div className="hit-row">
        <div className="hit-row__value">
          <Highlight attribute="value" hit={hit} />
        </div>
      </div>
    </div>
  )
}

export default CustomHit
